jQuery(document).ready(function ($) {

    $(".tiny-slider-carousel").each( function () {
       var slider = $(this).slick({
           dots: false,
           arrows: false,
           draggable: false,
           swipeToSlide: false,
           touchMove: false,
           swipe: false,
           infinite: false
       });


       slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
            $(".carousel-pagination li").removeClass("tns-nav-active");
            $(".carousel-pagination li[data-nav='"+currentSlide+"']").addClass("tns-nav-active");
        });

       $(".carousel-pagination li").click(function() {
           slideno = $(this).data('nav');
           slider.slick('slickGoTo', slideno);
       });
    });



});